exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".description_3HQX8rxI45uvzgsWCBJeO9 {\n  padding-bottom: 15px;\n}\n\n.description_3HQX8rxI45uvzgsWCBJeO9 > p {\n  font-size: 15px;\n  font-weight: 300;\n}\n", ""]);

// Exports
exports.locals = {
	"description": "description_3HQX8rxI45uvzgsWCBJeO9"
};